"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// CHECK FOR REMOVAL
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const material_1 = require("@mui/material");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Person_1 = __importDefault(require("@mui/icons-material/Person"));
const Search_1 = __importDefault(require("@mui/icons-material/Search"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const react_router_dom_1 = require("react-router-dom");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const Logo_1 = __importDefault(require("../../../common/components/Header/Logo"));
const LanguageDropdown_1 = __importDefault(require("../../../common/components/Header/LanguageDropdown"));
const BackButton_1 = __importDefault(require("./BackButton"));
const HeaderWrapper = styled_components_1.default.div `
  .MuiAppBar-root {
    background: ${(props) => props.isHeaderTransparent
    ? "linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(224, 224, 224, 0) 100%)"
    : props.theme.palette.colorAppBar.main};
    box-shadow: ${(props) => props.isHeaderTransparent ? "none" : "0px 0px 5px 0px rgba(0,0,0,0.75);"};

    transition:
      background 0.2s linear,
      box-shadow 0.2s linear;
    @media (min-width: 1024px) and (orientation: landscape) {
      background: ${(props) => !props.isHomepage
    ? props.theme.palette.colorAppBar.main
    : "linear-gradient(180deg, rgba(0, 0, 0, 0.3) 0%, rgba(224, 224, 224, 0) 100%)"};
      box-shadow: ${(props) => !props.isHomepage ? "0px 0px 5px 0px rgba(0,0,0,0.75)" : "none"};
    }
    .MuiIconButton-root {
      @media (max-width: 350px) {
        padding: 4px;
      }
    }

    .MuiSvgIcon-root {
      color: ${(props) => props.theme.palette.colorOnAppBar.main};
    }

    .MuiTypography-root {
      color: ${(props) => props.theme.palette.colorOnAppBar.main};
    }
    .icon-circle {
      background-color: ${(props) => props.theme.palette.colorAppBar.main};
    }
  }

  .Mui-disabled {
    display: none;
  }
`;
const LogoWrapper = styled_components_1.default.div `
  height: 100%;
  width: 100%;
  max-height: ${(props) => props.baseUrl === "/toscana-resort-castelfalfi" ? "64px" : "none"};
  display: ${(props) => props.baseUrl === "/toscana-resort-castelfalfi" ? "flex" : ""};
  align-items: ${(props) => props.baseUrl === "/toscana-resort-castelfalfi" ? "center" : "stretch"};

  img {
    display: block;
    max-width: 100%;
    margin: 0 auto;
    max-height: ${(props) => props.baseUrl === "/toscana-resort-castelfalfi" ? "90px" : "64px"};
    padding: 5px 0;
    transform: ${(props) => props.baseUrl === "/toscana-resort-castelfalfi" ? "scale(.5)" : "none"};
  }
`;
const Placeholder = styled_components_1.default.svg `
  width: 24px;
  height: 24px;
`;
const routesWithPageTitleInHeader = [
    {
        path: "bookings",
        locoKey: "tab_bookings",
    },
    {
        path: "guest_journey",
        locoKey: "api_guest_journey_my_reservations_title",
    },
    {
        path: "settings",
        locoKey: "tab_preferences",
    },
    {
        path: "contact",
        locoKey: "contact",
    },
];
const Header = (props) => {
    const [isHeaderTransparent, setIsHeaderTransparent] = (0, react_1.useState)(false);
    const [pageTitle, setPageTitle] = (0, react_1.useState)("");
    const { baseUrl, location, hideLogo, appData, userData, updateStore, history, withSearch, } = props;
    const isHomepage = location.pathname === baseUrl;
    const updateHeaderTransparency = (newValue) => {
        setIsHeaderTransparent(newValue);
        updateStore("isHeaderTransparent", newValue);
    };
    const onRouteChange = (newRoute) => {
        const path = newRoute.pathname.split("/").pop();
        const matchingPath = routesWithPageTitleInHeader.find((route) => route.path === path);
        if (matchingPath) {
            setPageTitle(i18n_js_1.default.t(matchingPath.locoKey));
        }
        else {
            setPageTitle("");
        }
        if (baseUrl === newRoute.pathname) {
            if (baseUrl === "/" && !appData.showBrandInfo) {
                updateHeaderTransparency(false);
            }
            else {
                updateHeaderTransparency(true);
            }
        }
        else {
            updateHeaderTransparency(props.isHeaderTransparent);
        }
    };
    (0, react_1.useEffect)(() => {
        updateHeaderTransparency(props.isHeaderTransparent);
    }, [props.isHeaderTransparent]);
    (0, react_1.useEffect)(() => {
        onRouteChange(location);
        history.listen(onRouteChange);
    }, []);
    const shouldProfileIconBeShown = () => {
        if (Object.keys(userData) && Object.keys(userData).length < 1) {
            return false;
        }
        const { loginProviders } = userData;
        console.log(loginProviders);
        console.log(userData);
        return (loginProviders.length > 0 &&
            location.pathname.split("/").pop() !== "profile");
    };
    const shouldBackButtonBeShown = () => history.location.pathname !== baseUrl;
    const showSearch = () => {
        updateStore("showSearch", true);
    };
    const goToUserPage = () => {
        history.push({
            pathname: `${baseUrl}${baseUrl !== "/" ? "/" : ""}profile`,
            search: location.search,
        });
    };
    const renderPlaceholder = (edge = false) => (react_1.default.createElement(IconButton_1.default, { edge: edge, onClick: goToUserPage, disabled: true, disableRipple: true, sx: { cursor: "default" } },
        react_1.default.createElement(Placeholder, null)));
    const renderProfileButton = (edge = false) => (react_1.default.createElement(IconButton_1.default, { color: "inherit", edge: edge, "aria-label": "account of current user", onClick: goToUserPage, className: "icon-circle", id: "aqa_home_page_account" },
        react_1.default.createElement(Person_1.default, { color: "colorOnAppBar" })));
    const renderBackAndProfileButton = () => {
        if (shouldBackButtonBeShown() && shouldProfileIconBeShown()) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(BackButton_1.default, null),
                renderProfileButton()));
        }
        if (!shouldBackButtonBeShown()) {
            if (shouldProfileIconBeShown()) {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    renderProfileButton("start"),
                    renderPlaceholder()));
            }
        }
        else if (!shouldProfileIconBeShown()) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(BackButton_1.default, null),
                renderPlaceholder()));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            renderPlaceholder("start"),
            renderPlaceholder()));
    };
    return (react_1.default.createElement(HeaderWrapper, { isHeaderTransparent: isHeaderTransparent, isHomepage: isHomepage },
        react_1.default.createElement(material_1.AppBar, { position: "fixed" },
            react_1.default.createElement(material_1.Toolbar, null,
                renderBackAndProfileButton(),
                !pageTitle && (react_1.default.createElement(react_1.default.Fragment, null,
                    !hideLogo && (react_1.default.createElement(LogoWrapper, { baseUrl: baseUrl },
                        react_1.default.createElement(Logo_1.default, null))),
                    withSearch && (react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(IconButton_1.default, { "aria-label": "search", color: "inherit", className: "icon-circle", onClick: showSearch, id: "aqa_navigation_search", sx: {
                                mr: "1vmin",
                            } },
                            react_1.default.createElement(Search_1.default, { color: "colorOnAppBar" })),
                        react_1.default.createElement(LanguageDropdown_1.default, null))))),
                pageTitle && (react_1.default.createElement(material_1.Typography, { noWrap: true, component: "div", sx: { flexGrow: 1, display: { sm: "block" } }, className: "page-title" }, pageTitle))))));
};
const mapStoreToProps = (store) => ({
    mode: store.getValue("mode"),
    baseUrl: store.getValue("baseUrl"),
    backofficeSettings: store.getValue("backofficeSettings"),
    isHeaderTransparent: store.getValue("isHeaderTransparent"),
    hideLogo: store.getValue("hideLogo"),
    appData: store.getValue("appData"),
    userData: store.getValue("userData"),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(Header));
